<template>
  <span class="api-copy-value">
    <span class="api-copy-value__text">{{ value }}</span>
    <button
      type="button"
      class="api-copy-value__button"
      :aria-label="`Copy ${label || value}`"
      @click="copy(value)"
    >
      <FontAwesomeIcon :icon="hasCopied ? ['fas', 'check'] : ['fak', 'copy']" />
    </button>
  </span>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { useCopyToClipboard } from '@/composables/useCopyToClipboard';

const { value, label = '' } = defineProps<{
  value: string;
  label?: string;
}>();

const { hasCopied, copy } = useCopyToClipboard();
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";

.api-copy-value {
  @apply inline-flex items-center gap-8 bg-neutral-background-weak rounded px-8 py-4
    font-mono text-sm text-neutral-text-strong max-w-full;
}

.api-copy-value__text {
  @apply truncate;
}

.api-copy-value__button {
  @apply inline-flex items-center justify-center w-12 text-neutral-accent
    hover:text-neutral-text cursor-pointer shrink-0 transition-colors;
}
</style>
